import React from 'react'
import List from '.'
const Stores = () => {
  return (
    <List>Stores Approvals</List>
  )
}

export default Stores